exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.address[data-v-184f9384] {\n  border: 1px dashed #CCC;\n  line-height: 1.25em;\n  padding: .5em;\n}\n", ""]);

// exports
